<script lang="ts">
	import { sharedConfig } from '$lib/animations';
	import Form from '@atoms/Form.svelte';
	import SearchInput from '@atoms/SearchInput.svelte';
	import { DateFormats, Theme } from '@tools';
	import { slide } from 'svelte/transition';

	let results = $state<any[]>([]);
	let query = $state('');
	let products = $state<any[]>([]);
	let selectedShowing = $state('');
	// let selectedGroup = $state('');
	let productsLink = $state('');

	let showings = $derived.by(() => {
		let showings = [];

		for (let result of results) {
			if (!result.eventId.startsWith('tix')) continue;

			for (let showing of result.showings) {
				console.log(showing);
				let id =
					result.eventId.replace('tix', '') +
					'/' +
					showing.ticketUrl.replace(result.ticketUrl, '').replaceAll('/', '');
				if (!id) continue;
				showings.push({
					id: id,
					title: result.title,
					date: showing.date
				});

				if (showings.length >= 10) break;
			}

			if (showings.length >= 10) break;
		}

		return showings;
	});

	$effect(() => {
		if (query.length >= 0) {
			productsLink = '';
			results = [];
			products = [];
		}
	});

	$effect(() => {
		products = [];

		if (selectedShowing) {
			productsLink = `https://billet.musikhuset.dk/da/buyingflow/dateproducts/${selectedShowing}`;
			const split = selectedShowing.split('/');

			fetch(`/api/v2/events/products?id=${split[1]}`)
				.then((r) => r.json())
				.then((res) => {
					if (res.data) products = res.data;
					else products = [];
				})
				.catch(console.error);
		}
	});

	const theme = $derived(Theme.name?.startsWith('cafe-') ? undefined : 'khaki-yellow');
</script>

<Form {theme}>
	<h3 class="text:h3">Bestil mad & drikke</h3>
	<p class="text:md">Vælg dit arrangement for at se bestillingsmuligheder</p>
	<div class="search">
		<SearchInput type="event" bind:results bind:query />
	</div>
	{#if showings.length > 0}
		<ul transition:slide={sharedConfig}>
			{#each showings as showing}
				<li>
					<input
						type="radio"
						class="input:checkbox"
						name="showing"
						value={showing.id}
						id={showing.id}
						onchange={(ev) => {
							if (ev.currentTarget.checked) selectedShowing = ev.currentTarget.value;
						}}
					/>
					<label for={showing.id} class="title">{showing.title}</label>
					<label for={showing.id} class="date">{DateFormats.dateWithWeekday(showing.date)}</label>
					<label for={showing.id} class="time">{DateFormats.timeOfDay(showing.date)}</label>
				</li>
			{/each}
		</ul>
	{/if}
	{#if products.length > 0 && selectedShowing && productsLink}
		<a href={productsLink} transition:slide={sharedConfig} class="products">
			{#each products as product}
				<span>{product.name}</span>
				<span>kr.</span>
				<span>{product.price},-</span>
			{/each}
		</a>
	{/if}
	<a
		class="link button:pill"
		aria-disabled={!productsLink}
		href={productsLink ?? undefined}
		target="_blank">Gå til bestilling</a
	>
	<p>
		Er spisning eller pausedrinks udsolgt til dit arrangement? Du kan købe drikkevarer i vores café,
		når du ankommer til Musikhuset.
	</p>
</Form>

<style lang="scss">
	.search {
		display: contents;

		:global(.SearchInput) {
			width: 100%;
		}
	}
	ul {
		list-style: none;
		padding: 0;
		display: grid;
		grid-template-columns: max-content 1fr max-content max-content;
		grid-auto-rows: max-content;
		width: 100%;
		padding: $gap2 0;
	}

	li {
		grid-column: 1 / -1;
		display: grid;
		grid-template-rows: max-content;
		grid-template-columns: max-content 1fr max-content max-content;
		grid-template-columns: subgrid;
		gap: 0 $gap2;
		padding: $gap1;
		transition: background-color $transition;

		&:hover {
			background-color: rgba(0, 0, 0, 0.15);
		}
	}

	.date {
		text-align: right;
	}

	.products {
		display: grid;
		grid-template-columns: 1fr max-content max-content;
		grid-auto-rows: max-content;
	}

	.link {
		width: 100%;
	}
</style>
